import { render, staticRenderFns } from "./PanelProductItems.vue?vue&type=template&id=1c4a497d&scoped=true&"
import script from "./PanelProductItems.vue?vue&type=script&lang=js&"
export * from "./PanelProductItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4a497d",
  null
  
)

export default component.exports